import { render } from "./ModalProfileAction.vue?vue&type=template&id=6e681684&scoped=true"
import script from "./ModalProfileAction.vue?vue&type=script&lang=js"
export * from "./ModalProfileAction.vue?vue&type=script&lang=js"

import "./ModalProfileAction.vue?vue&type=style&index=0&id=6e681684&scoped=true&lang=css"

import exportComponent from "/home/twig/Work/FRONT/adsquiz.front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e681684"]])

export default __exports__